import { useProducts } from "@pbm/products/hooks";
import { Title, Link, BreadCrumb } from "@funcional/react-ui";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { useMemo } from "react";
import { IProduct } from "@pbm/products/contracts";
import { Column } from "react-table";
import { useHistory } from "react-router-dom";
import { DefaultColumnFilter, GridView } from "@funcional/react-table-ui";

export default function ListProductPage() {
  const history = useHistory();

  const showRecord = (row: any) =>
    history.push(`/pbm/products/${row.original.ean}`);

  const columns: Column<IProduct>[] = useMemo(
    () => [
      {
        Header: "EAN",
        accessor: "ean",
        Filter: DefaultColumnFilter,
        Cell: ({ value }) => <Link to={`/pbm/products/${value}`}>{value}</Link>,
      },
      { Header: "Nome", accessor: "name" },
      { Header: "Embalagem", accessor: "package" },
      { Header: "Marca", accessor: "brand" },
      { Header: "Indústria", accessor: "industryName" },
      {
        Header: "Cadastro",
        accessor: "createdAt",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    []
  );

  return (
    <>
      <div className="flex items-center w-full mb-4">
        <div className="flex-1">
          <Title marginBottom={0}>Produtos</Title>
        </div>
      </div>

      <BreadCrumb items={[{ label: "Produtos" }]} />

      <GridView<IProduct>
        accessControlResourceName="products"
        showRecord={showRecord}
        columns={columns}
        hook={useProducts}
      />
    </>
  );
}
